<script lang="ts" setup>
import type { FormMessageProps } from '@fondof-ui/components/form/types'
import { useFormField } from '@fondof-ui/components/form/useFormField'
import { ErrorMessage } from 'vee-validate'

const { error, name, formMessageId } = useFormField()

const props = withDefaults(defineProps<FormMessageProps>(), {
  as: 'p',
})
</script>

<template>
  <ErrorMessage
    v-if="error"
    :id="formMessageId"
    :as="props.as"
    :class="props.class"
    :name="name"
  >
    {{ error }}
  </ErrorMessage>
</template>
